export const SMALL = "SMALL";
export const MEDIUM = "MEDIUM";
export const LARGE = "LARGE";
export const EXTRA_LARGE = "EXTRA_LARGE";
